<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="是否通过审核" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content" style="margin-top: 12px;">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData" v-if="this.formData.isNotAdd">
              <el-form-item label="登录账号" >
                <el-input type="text" autocomplete="off" v-model="formData.account" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData" v-else>

            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
import request from "@/router/axios";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf','param'],
  created() {
    console.log('a',this.wf)
    console.log('a',this.param)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
    if (this.param){
      this.exchangeNo = this.param.changeNo
      this.formData.id = this.param.orderId

    }

    this.getChangeEngineerStat();

  },
  data() {
    return {
      warehouseList: [],
      exchangeNo: '',

      formData: {
        id: null,
        processId: null,
        inWarehouseId: null,
        messageContent:null,
        account:null,
        isNotAdd:null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    loadWarehouse() {
			this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
			}).then(res => {
				this.warehouseList = res.data.data
			})
		},

    getChangeEngineerStat(){
      this.$http({
        url: "/basic/snUserChange/getById",
        method: 'post',
        data: {
          id: this.formData.id
        },
        isLoading: true,
        modalStrictly: true
      }).then(res => {
        console.log("res", res.data.data)
        if (res.data.data.changeType === 1){
            this.formData.isNotAdd = true
        }else {
          this.formData.isNotAdd = false
        }
      })
      console.log('1',this.formData.isNotAdd)
    },


    // 考核的确认
    siteAppeal() {
      console.log('2',this.formData.isNotAdd)
      if (!this.formData.account && this.formData.isNotAdd) {
        this.$message.error('登录账号必填')
        return false;
      }
      console.log('账号',this.formData.account)
      this.$http({
        url: "/basic/snUserChange/accountCheck",
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('确认成功')
        this.$emit('closeD')
        this.$emit('flushed')
        this.$emit('followUpAccountCheck', 1)
      })
    },

    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('followUpAccountCheck', 0)
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
      this.$emit('followUpAccountCheck', 0)
    }
  },
  mounted() {
    this.loadWarehouse()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
